<template>
  <div class="prizeSelect">
    <div>
      <v-row>
        <v-col cols="12" sm="4">
          <p class="text-h6 mb-0 mb-sm-4">達成賞</p>
        </v-col>
        <v-col cols="12" sm="8" style="display:flex;justify-content:flex-end;" class="pt-0 pt-sm-3 mb-3 pb-sm-5">
          <v-btn color="info" outlined @click="openPDF('prize_detail')">
            【達成賞】電子ポイントの主な特長
            <v-icon right dark>mdi-open-in-new</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          達成賞の対象となった時にお贈りする賞品（電子ポイント）を、下記よりお選びください。
        </v-col>
        <v-col clos="12" class="text-center" v-if="isLoading">
          <v-progress-circular indeterminate color="secondary" />
        </v-col>
      </v-row>
      <v-row v-if="!isLoading">
        <v-col clos="12" lg="10" offset-lg="1">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="prize in prizes" :key="prize.id">
                  <td>
                    <span style="font-size: 1.1rem">{{prize.name}}</span><br/>
                    <span v-if="prize.id === 'quo'" class="info--text">
                      多くの加盟店（ローソン、東急ハンズなど）で使えます。<b>スマホが必要です。</b>
                    </span>
                    <span v-if="prize.id === 'amazon'" class="info--text">
                      Amazonのアカウントが必要です。（実店舗では利用できません）
                    </span>
                    <span v-if="prize.id === 'book'" class="info--text">
                      QRコードを印刷することで書店でも利用できます。<b>スマホがない方にオススメ。</b>
                    </span>
                  </td>
                  <td style="width: 116px">
                    <a :href="prize.detail_url" style="text-decoration: none;" target="_blank">
                      <span style="text-decoration: underline;">利用方法</span>
                      <v-icon style="text-decoration: none;">
                        mdi-open-in-new
                      </v-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12">
          ※各電子ポイントの利用方法については利用方法リンクをクリックしてご確認ください。サポートデスクではお答えできません<br/>
          ※記録表（紙）参加の方は、従来どおり図書カード（現物）を2023年3月ごろに職場経由で配布します。
        </v-col>
        <v-col cols="12">
          <v-alert
            border="left"
            colored-border
            type="warning"
            elevation="2"
            style="font-size: 90%"
          >
            <span v-if="!isReadOnly">
              達成賞の賞品（電子ポイント）は、{{siteOpenDate}}～{{siteCloseDate}}まで、何度でも変更ができます。
            </span>
            <span v-else>
              <b>達成賞の賞品（電子ポイント）の変更可能期限が過ぎました。</b>
            </span>
            <br/>
            達成賞となった方に限り、達成賞送付時点の登録中メールアドレス宛に詳細をご案内いたします。（2023年1月を予定）<br/><br/>
            <p>※下記3つの条件を全て満たした場合、達成賞の対象となります。</p>
            <h4>達成賞条件</h4>
            <ol>
              <li>被保険者（本人）または18歳以上の被扶養者</li>
              <li>11/30時点で当健康保険組合に加入</li>
              <li>
                3コース以上達成（うち、アドバンスコースを2コース以上達成）<br/>
                ※「食事バッチリ！アプリチャレンジコース」と「禁煙コース」は1コース達成で対象となります。
              </li>
            </ol>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <v-form @submit.prevent ref="form" v-if="!isLoading">
      <v-row align="center">
        <v-col
          cols="12"
          md="8" offset-md="2"
        >
          <v-select
            v-model="selectedPrize"
            :items="prizesOptionsList"
            label="達成賞賞品"
            hide-details="auto"
            :disabled="isReadOnly"
            outlined
            dense
          ></v-select>
        </v-col>
      </v-row>
      <div class="text-center" v-if="!isReadOnly">
        <v-btn
          type="submit"
          :loading="isSubmitting"
          @click="save"
          class="mt-2"
          color="primary"
        >
          保存
        </v-btn>
      </div>
    </v-form>
    <SuccessSnackbar ref="snackbar"/>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')

// 達成賞賞品リストの取得
const listPrizeQuery = (campaignId) => `
  query listPrize {
    listPrize(
      campaign_id: "${campaignId}"
      is_chooseable: true
      ) {
      prizes {
        id
        name
        is_default
        sort_order
        detail_url
        caution
      }
    }
  }
`
const getListPrizeQuery = async (campaignId) => {
  const { data: { listPrize: data } } = await GraphqlAPI(listPrizeQuery(campaignId))
  return data
}

// 達成賞選択賞品の取得
const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      select_prize
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return data
}

// 達成賞の登録
const selectPrizeMutation = (campaignId, selectPrizeId) => `
  mutation selectPrize {
    selectPrize(
      campaign_id: "${campaignId}"
      prize_id: "${selectPrizeId}"
    )
  }
`
const selectPrize = async (campaignId, selectPrizeId) => {
  const { data: { createWatch: data } } = await GraphqlAPI(selectPrizeMutation(campaignId, selectPrizeId))
  return data
}

export default {
  name: 'prizeSelect',
  components: { SuccessSnackbar },
  data () {
    return {
      prizes: [],
      prizesOptionsList: [],
      selectedPrize: null,
      siteOpenDate: null,
      siteCloseDate: null,
      isReadOnly: false,
      isLoading: false,
      isSubmitting: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  created () {
    this.fetchListPrize()
  },
  methods: {
    async fetchListPrize () {
      try {
        this.isLoading = true
        const userview = await getUserViewInfo(this.campaign.id)
        const listPrizeResult = await getListPrizeQuery(this.campaign.id)
        this.prizes = listPrizeResult.prizes
        this.selectedPrize = userview.select_prize ? userview.select_prize : this.prizes.find(item => item.is_default).id
        this.prizesOptionsList = this.prizes.map(item => {
          return { text: item.name, value: item.id }
        })
        this.siteOpenDate = dayjs(this.campaign.site_open, 'YYYY-MM-DD').format('M/D')
        this.siteCloseDate = dayjs(this.campaign.site_close, 'YYYY-MM-DD').format('M/D')
        this.isReadOnly = dayjs() > dayjs(this.campaign.site_close, 'YYYY-MM-DD').add(1, 'days')
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.$emit('errorHandling', '達成賞の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async save () {
      try {
        this.isSubmitting = true
        await selectPrize(this.campaign.id, this.selectedPrize)
        await this.$refs.snackbar.open('達成賞を更新しました。')
        this.isSubmitting = false
      } catch (e) {
        this.$emit('errorHandling', '達成賞の更新に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.prize-title {
  margin-bottom: 1rem;
}
</style>
